import classNames from 'classnames';
import React, { useMemo } from 'react';

import { Typography } from '@sravni/react-design-system';

import * as Icons from '../Icons/Course';

import styles from './currencies.module.scss';

enum CurrencyDirection {
  UP = 'up',
  DOWN = 'down',
}

type TCurrencyItem = {
  link?: string;
  code: string;
  name?: string;
};

interface ICurrencyItemProps {
  currency: {
    dateFrom;
    dateTo;
  };
  item: TCurrencyItem;
}

const getIcon = (type: CurrencyDirection): JSX.Element => {
  switch (type) {
    case CurrencyDirection.UP:
      return <Icons.Up />;

    default:
      return <Icons.Down />;
  }
};

const getCurrencyString = (number: number): string =>
  number >= 1000
    ? String(Math.round(number)).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
    : number.toFixed(2).replace('.', ',');

const CurrencyItem: React.FC<ICurrencyItemProps> = React.memo(({ currency, item }) => {
  const curDir: CurrencyDirection = useMemo(() => {
    return currency?.dateTo?.price > currency?.dateFrom?.price ? CurrencyDirection.UP : CurrencyDirection.DOWN;
  }, [currency]);

  const diff: number = useMemo(() => Math.abs(currency?.dateTo?.price - currency?.dateFrom?.price), [currency]);

  if (!(currency && currency.dateFrom && currency.dateTo)) {
    return null;
  }

  return (
    <Typography.Text size={14} uppercase className={styles.currencyItem}>
      <span className={classNames('h-color-D60', styles.currencyItem__currency)}>
        {item.link ? (
          <Typography.Link href={item.link} color={'gray'}>
            {item.code}
          </Typography.Link>
        ) : (
          <span>{item.name || item.code}</span>
        )}
      </span>
      <span className={styles.inlineNowrap}>
        <span className={styles.currencyItem__course}>{getCurrencyString(currency.dateTo.price)}</span>
        <span className={classNames(styles.currencyItem__diff, styles[`currencyItem__diff--${curDir}`])}>
          {getCurrencyString(diff)}
        </span>
        {getIcon(curDir)}
      </span>
    </Typography.Text>
  );
});

export default CurrencyItem;
